import React from "react";
import { motion } from "framer-motion";
import PublicLayout from "@/components/PublicLayout";
import { useSiteContent } from "@/context/SiteContentContext";
import { Target, Heart, Cpu } from "lucide-react";

const VALUE_ICONS = [Target, Cpu, Heart];

export default function AboutPage() {
  const { content, resolveImg } = useSiteContent();
  const a = content.about;

  return (
    <PublicLayout>
      <section className="pt-32 pb-16 text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <p className="text-sm font-bold uppercase tracking-widest text-rose-400">{a.hero_kicker}</p>
          <h1 className="font-heading text-5xl font-extrabold mt-2">{a.hero_title}</h1>
        </div>
      </section>

      <section className="py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid md:grid-cols-2 gap-12 items-center">
          <motion.div initial={{ opacity: 0, x: -24 }} whileInView={{ opacity: 1, x: 0 }} viewport={{ once: true }}
            className="rounded-2xl h-96 bg-slate-900/70 border border-white/10 flex items-center justify-center shadow-xl relative overflow-hidden">
            <img src={resolveImg(a.image)} alt="Officina Dentale 3D" className="h-60 object-contain relative" />
          </motion.div>
          <motion.div initial={{ opacity: 0, x: 24 }} whileInView={{ opacity: 1, x: 0 }} viewport={{ once: true }}>
            <h2 className="font-heading text-3xl font-bold text-white">{a.section_title}</h2>
            <p className="mt-5 text-slate-400 leading-relaxed">{a.para1}</p>
            <p className="mt-4 text-slate-400 leading-relaxed">{a.para2}</p>
          </motion.div>
        </div>
      </section>

      <section className="py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid md:grid-cols-3 gap-8">
          {(a.values || []).map((v, i) => {
            const Icon = VALUE_ICONS[i] || Target;
            return (
              <motion.div key={i} initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: i * 0.1 }}
                className="p-8 rounded-2xl bg-slate-900/70 border border-white/10 text-center">
                <div className="h-14 w-14 rounded-2xl bg-teal-500/15 flex items-center justify-center mx-auto mb-5"><Icon className="h-7 w-7 text-teal-600" /></div>
                <h3 className="font-heading text-xl font-semibold text-white">{v.title}</h3>
                <p className="mt-2 text-slate-400 leading-relaxed">{v.desc}</p>
              </motion.div>
            );
          })}
        </div>
      </section>
    </PublicLayout>
  );
}
